import { FileOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'

export const StyledFileOutlined = styled(FileOutlined)`
  font-size: 30px;
  padding-left: 15px;
`
